import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge17 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ場の会員になる方法' fontWeight={700} />
                <p>
                    ゴルフ場の会員になるためには、『ゴルフ会員権』の取得が必要です。
                    <br />
                    会員権を取得するには、次の２つの方法があります。
                    <br />
                    <br />
                    ・知人や友人などと直接取り引きして取得するケース
                    <br />
                    ・ゴルフ会員権業者に売買を依頼するケース
                    <br />
                    <br />
                    個人間で取引すると、書類作成など複雑な手続きを全て自分でしなければいけない上に、金銭面でのトラブルも起こりやすくなります。
                    <br />
                    以前は個人間取引も頻繁に行われていましたが、現在ではゴルフ会員権業者に依頼する方法が主流です。
                    <br />
                    業者を通してゴルフ会員権を取得すれば、売買金額の交渉や書類作成など複雑な手続きを代行してもらえるので、時間や手間を少なく出来ます。
                    <br />
                    ゴルフ場に関する知識、市場の最新情報にも詳しいため、トラブルに巻き込まれることなく安心してお取引いただけます。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ場の会員になるまでの流れ-会員権購入～面接～入会まで-' fontWeight={700} />
                <p>
                    ゴルフ場の会員になるためには、『ゴルフ会員権』の取得が必要でゴルフ会員権を購入するだけでは、会員としてプレーを始めることは出来ません。
                    会員権の購入から入会まで、どのような流れで手続きが進むのか、一例を紹介しますので、ぜひ参考にしてください。
                </p>

                <Heading3 title='１．ゴルフ会員権の購入' />
                <p>
                    まずは予算や立地をふまえて、会員権を購入するゴルフ場を検討します。
                    <br />
                    法人入会しか出来ないゴルフ場などもありますので、ゴルフ場が定める入会条件についてもあらかじめ確認しておくとスムーズに進められます。
                    <br />
                    会員権を購入するゴルフ場が決まったら信頼できるゴルフ会員権業者に会員権の取得を依頼し、担当者と相談しつつ話を進めましょう。
                </p>

                <Heading3 title='２．入会手続き・書類審査' />
                <p>
                    ゴルフ会員権を購入した後は、入会手続きを済ませて書類審査へ進みます。
                    <br />
                    入会に必要な書類をそろえてゴルフ場に提出するのですが、入会申込書の他にも、住民票・戸籍謄本・印鑑証明書など、市区町村で発行される公的書類が必要な場合もあります。
                    <br />
                    ゴルフ場によって必要書類が異なりますので、不備のないよう事前によく確認しておきましょう。
                    <br />
                    書類提出後は書類審査が行われます。
                </p>

                <Heading3 title='３．面接' />
                <p>
                    書類審査を通過したら、一部のゴルフ場では面接が行われます。
                    <br />
                    面接で質問される内容や注意点などを面接前にチェックしておくと、実際の面接時に安心です。
                    <br />
                    面接についてはこのあと詳しくご紹介します。
                </p>

                <Heading3 title='４．名義書換料の支払い・登録完了' />
                <p>
                    面接終了後、理事会等を経て、問題なく通過したら入会の承認通知を受け取り、名義書換料の支払いを終え、ゴルフ会員権取得の手続きは完了です。
                    <br />
                    一般的には、支払いを終えた時点でゴルフ場の会員として扱われます。
                    <br />
                    証券やネームプレートなどは、名義書換料を支払い、しばらく経ってからお手元に届きます。
                    <br />
                    登録完了までの日数はゴルフ場によって異なり、最短であれば２０日ほど、理事会の開催をもって会員の承認を行っているゴルフ場で、理事会の開催が頻繁に行われていない場合だと数ヶ月かかってしまうこともあります。
                    <br />
                    申し込みからゴルフ会員権発行までのおおよその期間については、個別にお問合せください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='入会審査の面接で気を付けるべきポイントとは' fontWeight={700} />
                <p>
                    入会審査時の面接ではどのようなことを聞かれるのか、不安に思っている方もいらっしゃるのではないでしょうか。
                    <br />
                    特に格式の高いゴルフ場となると、複数回に分けて面接を行うケースもありますので実際の面接で困らないよう、想定される質問や気を付けておきたいポイントについてご紹介します。
                </p>

                <Heading3 title='面接で聞かれること' />
                <p>
                    ゴルフ会員権取得の面接としてよくある質問は、ゴルフの経験年数や年間のラウンド回数、職業の話などが挙げられます。
                    <br />
                    「なぜ当クラブを選んだのか？」という入会動機についても問われることが多いので、入会への熱意を伝えましょう。
                    <br />
                    ゴルフ場側から質問される以外にも、予約方法や競技会などゴルフ場の運営体制についての説明を受ける場合もあります。
                </p>

                <Heading3 title='面接で気を付けるポイント' />
                <p>
                    面接では、マナーや周りを気遣いつつプレーが出来る人物か、協調性があるか、メンバー同士のコミュニケーションが取れるかなどの点がチェックされています。
                    <br />
                    ゴルフ場の担当者と世間話で親睦を深めること自体は問題ありませんが、横柄な態度や非常識な発言が見られると、最悪の場合は入会を否認されることもありますのでゴルフ場にふさわしい人物と判断されるよう、態度やマナー違反には十分に注意が必要です。
                    <br />
                    面接の判断基準はゴルフ場ごとに様々で、統一された決まりが存在するわけではありません。
                    <br />
                    ゴルフ場によっては、入会希望者だけでなく、推薦者が面接に帯同しなくてはならないこともあります。
                    <br />
                    実際にプレーを行い、マナーや腕前、ルールの理解度などをチェックされることもあるため、相応の準備と心構えが大切です。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='面接する時の服装のマナーについて' fontWeight={700} />
                <p>
                    ゴルフ場の会員となるためには、面接時の服装についても十分な配慮が求められます。
                    <br />
                    清潔感のある格好をするのはもちろんですが、男性はスーツとネクタイ、女性はジャケットを羽織るなど、フォーマルな服装を選びましょう。
                    <br />
                    ジーンズやサンダル、スニーカーなどカジュアルな服装は、面接に限らずゴルフ場のドレスコードとしてふさわしくありません。
                    <br />
                    ゴルフ場によってドレスコードの基準が異なるためゴルフ会員権業者から情報を得たりゴルフ場に問合せたりして、ドレスコードを前もって確認しておくと安心でしょう。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='面接に関することは事前に確認を' fontWeight={700} />
                <p>
                    ゴルフ場の会員になるためには、会員権を購入したあと、書類審査や面接が設けられている場合があります。
                    <br />
                    面接でチェックされるポイントを事前に理解しておけば、本番も滞りなく終えることが出来るでしょう。
                    <br />
                    入会する際に面接がないゴルフ場もあるので、ゴルフ会員権業者に確認しておくのがおすすめです。
                    <br />
                    万が一、入会審査に落ちてしまった場合の理由と対策については
                    <a href='/knowledge/51'>入会審査に落ちる理由と対策</a>
                    で、入会動機書の書き方については
                    <a href='/knowledge/53'>入会動機書の書き方・例文</a>
                    で詳しくご紹介しています。
                    <br />
                    ご不明点がありましたら、業界随一の情報量と実績を誇る「住地ゴルフ」にぜひお問合せください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge17;
